import { variables } from '@indriver/yrel';

var preset = {
  background: {
    default: variables['background-primary'],
    selected: variables['extensions-background-lightaccent'],
    enabled: variables['statement-background-primarypressed'],
    success: variables['background-primary'],
    error: variables['background-primary']
  },
  disabledBackground: variables['background-primary'],
  focusedBorderColor: variables['extensions-border-accent'],
  mainColor: {
    default: variables['text-and-icon-primary'],
    selected: variables['text-and-icon-primary'],
    enabled: variables['text-and-icon-primary'],
    success: variables['extensions-text-and-icon-success'],
    error: variables['extensions-text-and-icon-error']
  },
  disabledColor: variables['text-and-icon-disabled'],
  minHeight: {
    xs: '40px',
    s: '48px',
    m: '56px',
    l: '78px'
  },
  minHeightWithSecondary: {
    xs: '56px',
    s: '56px',
    m: '65px',
    l: '80px'
  },
  topPadding: {
    xs: '8px',
    s: '8px',
    m: '12px',
    l: '16px'
  },
  bottomPadding: {
    xs: '8px',
    s: '8px',
    m: '12px',
    l: '16px'
  },
  topPaddingWithoutSecondary: {
    xs: '9px',
    s: '12px',
    m: '16px',
    l: '16px'
  },
  bottomPaddingWithoutSecondary: {
    xs: '8px',
    s: '13px',
    m: '16px',
    l: '16px'
  },
  topPaddingLoading: {
    xs: '12px',
    s: '10px',
    m: '12.5px',
    l: '20px'
  },
  topPaddingLoadingWithoutSecondary: {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '16px'
  },
  bottomPaddingLoading: {
    xs: '12px',
    s: '10px',
    m: '12.5px',
    l: '20px'
  },
  bottomPaddingLoadingWithoutSecondary: {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '16px'
  },
  leftPadding: {
    default: '16px',
    prefixed: '0',
    postfixed: '16px',
    both: '0'
  },
  rightPadding: {
    default: '16px',
    prefixed: '16px',
    postfixed: '0',
    both: '0'
  },
  disabledCursor: 'default'
};
var prefixContainerPreset = {
  paddingLeft: '16px',
  paddingTop: {
    xs: '8px',
    s: '12px',
    m: '16px',
    l: '16px'
  },
  paddingTopLoading: {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '16px'
  },
  paddingTopWithSecondary: {
    xs: '8px',
    s: '8px',
    m: '16px',
    l: '16px'
  },
  paddingRight: {
    xs: '8px',
    s: '8px',
    m: '16px',
    l: '16px'
  },
  iconSize: {
    xs: '24px',
    s: '24px',
    m: '24px',
    l: '48px'
  }
};

export { preset as default, prefixContainerPreset };
